import { Box} from "@mui/material";
import { Route, Routes } from "react-router-dom";
import Overview from "../../pages/Overview";
import Students from "../../pages/Students";
import Lessons from "../../pages/Lessons";
import Codes from "../../pages/Codes";
import Attendance from "../../pages/Attendance";
import { Settings } from "@mui/icons-material";
import AttendanceReport from "../../reports/AttendanceReport";
import Homework from "../../pages/Homework";
import Exam from "../../pages/Exam";
import EducationStages from "../../pages/EducationStage";
import Center from "../../pages/Center";
import Results from "../../pages/Results";

function Main() {
  return (
    <Box component="main">
      <Routes>
        <Route path="/overview" element={<Overview />} />
        <Route path="/students" element={<Students />} />
        <Route path="/lessons" element={<Lessons />} />
        <Route path="/codes" element={<Codes />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/attendance" element={<Attendance />} />
        <Route path="/attendance-report" element={<AttendanceReport />} />
        <Route path="/homework" element={<Homework />} />
        <Route path="/exam" element={<Exam />} />
        <Route path="/education-stages" element={<EducationStages />} />
        <Route path="/centers" element={<Center />} />
        <Route path="/results" element={<Results />} />

      </Routes>
    </Box>
  );
}

export default Main;
